import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import {
  playHoverSwoosh,
  playEnterSound,
} from "@/components/shared/ambient-sound";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes("@")) {
      toast.error("Drop a real email, founder.");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      playEnterSound();
      toast.success("You're in. Welcome to the conversation.", {
        description: "Check your inbox — Vol. 12 drops Sunday.",
      });
      setEmail("");
      setLoading(false);
    }, 700);
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative bg-[#050505] px-6 md:px-10 lg:px-16 py-24 md:py-40 overflow-hidden grain"
    >
      {/* Giant ghost headline */}
      <h2
        aria-hidden
        className="pointer-events-none absolute -top-4 -left-2 right-0 font-display font-extrabold uppercase leading-[0.8] tracking-tighter select-none whitespace-nowrap"
        style={{
          fontSize: "clamp(120px, 22vw, 420px)",
          color: "transparent",
          WebkitTextStroke: "1px rgba(255,255,255,0.05)",
        }}
      >
        Unplugged.
      </h2>

      <div className="relative z-10 max-w-4xl">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-flare mb-6">
          /08 — the newsletter
        </p>
        <h3
          data-testid="newsletter-heading"
          className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.95]"
        >
          Be part of the <br />
          NCR startup <br />
          <span className="italic font-normal text-flare">conversation.</span>
        </h3>
        <p className="mt-6 max-w-xl text-bone-muted text-base md:text-lg leading-relaxed">
          One email, every Sunday. Founder stories, quiet deals, and the
          conversations actually happening behind closed doors. No spam. No
          hot-takes. Just lived context.
        </p>

        <form
          onSubmit={handleSubmit}
          noValidate
          data-testid="newsletter-form"
          className="mt-10 max-w-2xl"
        >
          <div className="flex items-end border-b-2 border-white/20 focus-within:border-flare transition-colors">
            <input
              data-testid="newsletter-email-input"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@founder.com"
              className="flex-1 bg-transparent font-display text-xl md:text-3xl text-bone placeholder:text-white/20 outline-none py-4 min-w-0"
            />
            <button
              type="submit"
              data-testid="newsletter-submit-btn"
              disabled={loading}
              onMouseEnter={playHoverSwoosh}
              className="group font-mono text-xs md:text-sm uppercase tracking-[0.2em] text-flare hover:text-bone transition-colors flex items-center gap-2 pb-5 pl-4 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Subscribe"}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-bone-muted">
            9,200+ founders, operators, and investors already in.
          </p>
        </form>
      </div>
    </section>
  );
};
